import { render, staticRenderFns } from "./bni.vue?vue&type=template&id=7abde55a&scoped=true"
import script from "./bni.vue?vue&type=script&lang=js"
export * from "./bni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abde55a",
  null
  
)

export default component.exports